<template>
  <div
    id="container"
    class="d-flex justify-content-center align-items-center w-100"
  >
    <Logo />

    <form
      id="form"
      class="d-flex flex-column"
      style="transition: all 0.5s ease-in-out"
      @submit.prevent="updatePassword()"
    >
      <span>
        <h1
          style="
            font-style: normal;
            font-weight: 700;
            font-size: 34px;
            margin-bottom: 10px;
          "
        >
          Troque sua senha
        </h1>
        <p
          style="
            color: var(--grey-medium);
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            margin-bottom: 0;
            max-width: 329px;
          "
        >
          Para a sua segurança, realize abaixo a troca da sua senha temporária
          para uma de maior segurança.
        </p>
      </span>
      <div class="d-flex flex-wrap align-items-start mt-5">
        <!-- TODO: criar props para minimizar linhas de cod e fácil manutenção -->
        <img
          v-if="!changedPassword"
          :src="require('@/assets/images/svg/ícone-emblema-seguraça.svg')"
          alt=""
          style="margin: 0 10px 10px 10px"
        />
        <img
          v-if="changedPassword"
          :src="
            require('@/assets/images/svg/ícone-emblema-segurança-alterado.svg')
          "
          alt=""
          style="margin: 0 10px 10px 10px"
        />
        <span class="d-flex flex-column align-items-start">
          <p
            v-if="!changedPassword"
            style="
              color: var(--black-medium);
              font-style: normal;
              font-weight: 500;
              font-size: 16px;
              margin-bottom: 0;
            "
          >
            Nova Senha
          </p>
          <p
            v-if="changedPassword"
            style="
              color: var(--black-medium);
              font-style: normal;
              font-weight: 500;
              font-size: 16px;
              margin-bottom: 0;
            "
          >
            Sua senha foi alterada!
          </p>
          <p
            v-if="!changedPassword"
            style="
              color: var(--grey-medium);
              font-style: normal;
              font-weight: 400;
              font-size: 16px;
              margin-bottom: 0;
            "
          >
            <b style="font-weight: 700">Crie uma senha </b><br /><br />
            • Mínimo 8 caracteres<br />
            • Letras maiúsculas e minúsculas<br />
            • Número e símbolos
          </p>
          <p
            v-if="changedPassword"
            style="
              color: var(--grey-medium);
              font-style: normal;
              font-weight: 400;
              font-size: 16px;
              margin-bottom: 0;
              max-width: 242px;
            "
          >
            A partir de agora você pode entrar usando sua nova senha
          </p>
        </span>
      </div>
      <div
        v-if="!changedPassword"
        class="d-flex flex-column w-100 justify-content-between align-items-start"
      >
        <Input
          :inputType="typePassword"
          :inputValue="user.password"
          :required="true"
          :isValid="isOkPassword"
          inputId="password"
          inputLabel="Senha"
          inputName="Password"
          style="margin-top: 24px"
          @onUpdate="(value) => handleInputValue('password', value)"
          @isValid="isValid()"
          @clickVerSenha="clickVerSenha('typePassword')"
        />
        <span v-if="!isOkPassword">
          <p
            style="
              font-style: normal;
              font-weight: 400;
              font-size: 13px;
              margin: 5px 0;
              color: var(--red-medium);
            "
          >
            {{ statusPassword }}
          </p>
        </span>
        <Input
          inputId="confirmPassword"
          :inputType="typeConfirmPassword"
          :inputValue="confirmPassword"
          :required="true"
          :isValid="isOkConfirmPassword"
          inputLabel="Confirmar senha"
          inputName="Password"
          style="margin-top: 24px"
          @onUpdate="(value) => handleInputValue('confirmPassword', value)"
          @clickVerSenha="clickVerSenha('typeConfirmPassword')"
          @isValid="isValid()"
        />
        <span v-if="confirmPassword.length > 0">
          <p
            v-if="!isPasswordMatch"
            style="
              font-style: normal;
              font-weight: 400;
              font-size: 13px;
              margin: 5px 0;
              color: var(--red-medium);
            "
          >
            As senhas não conferem
          </p>
        </span>

        <button
          class="btn w-100 border-0 mt-5"
          type="submit"
          style="
            text-align: center;
            color: var(--white);
            background-color: var(--blue-medium);
            padding: 18px 0;
            border-radius: 8px;
          "
        >
          Entrar
        </button>
      </div>
      <button
        v-if="changedPassword"
        class="btn w-100 border-0 mt-5 text-center"
        type="button"
        style="
          text-align: center;
          color: var(--white);
          background-color: var(--blue-medium);
          padding: 18px 0;
          border-radius: 8px;
        "
        @click="redirectDash()"
      >
        Continuar
        <img
          style="margin-left: 15px"
          :src="require('@/assets/images/svg/ícone-seta-direita.svg')"
          alt=""
        />
      </button>
    </form>
  </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
import Input from "../components/Input.vue";
import Logo from "@/components/Logo.vue";

export default {
  name: "ResetPassword",
  components: {
    Input,
    Logo,
  },
  data() {
    return {
      user: {
        email: "",
        password: "",
      },
      isOkPassword: false,
      isOkConfirmPassword: false,
      isPasswordMatch: false,
      typePassword: "",
      typeConfirmPassword: "",
      statusPassword: "",
      changedPassword: false,
      confirmPassword: "",
    };
  },
  created() {
    this.typePassword = "password";
    this.typeConfirmPassword = "password";
  },
  methods: {
    ...mapActions(["resetPassword"]),
    ...mapMutations(["setToken"]),

    async updatePassword() {
      try {
        const response = await this.resetPassword({
          ...this.user,
          email: localStorage.getItem("email"),
        });
        this.setToken(response.data.token);
        localStorage.setItem("token", JSON.stringify(response.data.token));
        this.changedPassword = true;
      } catch (error) {
        switch (error.status) {
          case 400:
            break;
          case 500:
            break;
          default:
            break;
        }
      }
    },
    handleInputValue(propertyName, propertyValue) {
      if (propertyName == "confirmPassword") {
        this.confirmPassword = propertyValue;
      } else {
        this.user = Object.assign(
          {},
          this.user,
          this.setObjectProperty(this.user, propertyName, propertyValue)
        );
      }
    },
    isValid() {
      let isValidPassword = document.getElementById("password").value;
      let btnSubmit = document.querySelector('button[type="submit"]');
      let isValidConfirmPassword =
        document.getElementById("confirmPassword").value;

      let ucase = new RegExp("[A-Z]+");
      let lcase = new RegExp("[a-z]+");
      let num = new RegExp("[0-9]+");
      let specialcharacter = new RegExp(/\W|_/);

      // condição que verifica se a senha contém os requisitos para nova senha
      if (isValidPassword != "") {
        if (
          !(isValidPassword.length > 0 && isValidPassword.length >= 8) ||
          !ucase.test(isValidPassword) ||
          !lcase.test(isValidPassword) ||
          !num.test(isValidPassword) ||
          !specialcharacter.test(isValidPassword)
        ) {
          this.statusPassword = "Senha não atende aos requisitos de segurança";
          this.isOkPassword = false;
        } else {
          this.statusPassword = "";
          this.isOkPassword = true;
        }
      } else {
        this.statusPassword = "";
        this.isOkPassword = true;
      }

      //condição que verifica a nova senha se condiz com a confirmação da nova senha
      if (!(isValidConfirmPassword === this.user.password)) {
        this.isOkConfirmPassword = false;
        this.isPasswordMatch = false;
        btnSubmit.disabled = true;
      } else {
        this.isOkConfirmPassword = true;
        this.isPasswordMatch = true;
        btnSubmit.disabled = false;
      }

      //Desativa o disabled do button type submit(ao estado default)
      if (isValidPassword == "" || isValidConfirmPassword == "") {
        btnSubmit.disabled = false;
      }
    },
    clickVerSenha(campo) {
      if (campo === "typePassword") {
        if (this.typePassword === "password") {
          this.typePassword = "text";
        } else if (this.typePassword === "text") {
          this.typePassword = "password";
        }
      }
      if (campo === "typeConfirmPassword") {
        if (this.typeConfirmPassword === "password") {
          this.typeConfirmPassword = "text";
        } else if (this.typeConfirmPassword === "text") {
          this.typeConfirmPassword = "password";
        }
      }
    },
    redirectDash() {
      this.$router.push({ name: "Dashboard" });
    },
  },
};
</script>
<style scoped>
#form {
  margin: 10px;
  max-width: 513px;
  background-color: var(--white);
  border-radius: 16px;
  padding: 54px;
}
#logo {
  left: 24px;
  top: 64px;
  position: absolute;
}
@media only screen and (max-width: 764px) {
  #logo {
    left: 0;
    top: 0;
    position: initial;
    margin-top: 10px;
  }
}
@media only screen and (max-width: 800px) {
  #form {
    padding: 30px;
    margin: 20px;
  }
}
</style>
